function include(context) {
  context.keys().forEach(context)
}

const components = require.context('../../components', true, /component\.js$/)
include(components);
